import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Shows a small indicator in chart config drawer headers when a dashboard-level
 * date filter is active. This is purely informational so researchers know the time period they configure will
 * be overridden on the dashboard for viewers.
 *
 * Note: ChartConfigDrawer renders outside <RouterProvider>, so we read the URL
 * directly via window.location.search instead of useSearchParams.
 */
const DashboardDateFilterBanner: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const dfStart = params.get("df_start");
  const dfEnd = params.get("df_end");

  if (!dfStart || !dfEnd) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        p: 0.5,
        backgroundColor: "#eff6ff",
        border: "1px solid #bfdbfe",
        borderRadius: 1,
        flexShrink: 0,
      }}
    >
      <Typography variant="caption" color="primary" fontWeight={500}>
        Dashboard date filter active: {dfStart} – {dfEnd}
      </Typography>
    </Box>
  );
};

export default DashboardDateFilterBanner;
